export default __webpack_public_path__ + "static/media/blog-3.d9c45891.jpg";